import { render, staticRenderFns } from "./SessionExpired.vue?vue&type=template&id=80859dba&scoped=true&"
import script from "./SessionExpired.vue?vue&type=script&lang=js&"
export * from "./SessionExpired.vue?vue&type=script&lang=js&"
import style0 from "./SessionExpired.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SessionExpired.vue?vue&type=style&index=1&id=80859dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80859dba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
